@if (repairTaskData()) {
  <wr-chart
    [labels]="repairTaskLabels()"
    [showLegend]="false">
    @for (dataset of repairTaskData(); track dataset.label) {
      <wr-dataset
        type="bar"
        [data]="dataset.data"
        [label]="dataset.label"
        [backgroundColor]="dataset.backgroundColor"
        indexAxis="y"
        stack="repairTasks">
      </wr-dataset>
    }
  </wr-chart>
}
